import { Routes } from '@angular/router';
import { BaseLayoutComponent } from './layout/base-layout.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then(m => m.LoginPage)
  },
  // Maintenance-workflow-redesign-plan.md, Phase 4.5 — top-level route (not nested under
  // BaseLayoutComponent) so there is no app-shell chrome (sidebar/header) to hide when printing.
  {
    path: 'work-orders/print',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/work-orders/work-order-print.page').then(m => m.WorkOrderPrintPage)
  },
  {
    path: '',
    component: BaseLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dev/components',
        loadComponent: () => import('./pages/dev-components.page').then(m => m.DevComponentsPage)
      },
      {
        path: 'lookups/areas',
        loadComponent: () => import('./pages/areas/area-list.page').then(m => m.AreaListPage)
      },
      {
        path: 'lookups/areas/new',
        loadComponent: () => import('./pages/areas/area-form.page').then(m => m.AreaFormPage)
      },
      {
        path: 'lookups/areas/:id/edit',
        loadComponent: () => import('./pages/areas/area-form.page').then(m => m.AreaFormPage)
      },
      {
        path: 'lookups/complaint-types',
        loadComponent: () => import('./pages/complaint-types/complaint-type-list.page').then(m => m.ComplaintTypeListPage)
      },
      {
        path: 'lookups/complaint-types/new',
        loadComponent: () => import('./pages/complaint-types/complaint-type-form.page').then(m => m.ComplaintTypeFormPage)
      },
      {
        path: 'lookups/complaint-types/:id/edit',
        loadComponent: () => import('./pages/complaint-types/complaint-type-form.page').then(m => m.ComplaintTypeFormPage)
      },
      {
        path: 'lookups/refrigerants',
        loadComponent: () => import('./pages/refrigerants/refrigerant-list.page').then(m => m.RefrigerantListPage),
        data: { breadcrumb: 'REFRIGERANTS.TITLE' }
      },
      {
        path: 'lookups/refrigerants/new',
        loadComponent: () => import('./pages/refrigerants/refrigerant-form.page').then(m => m.RefrigerantFormPage),
        data: { breadcrumb: 'REFRIGERANTS.NEW' }
      },
      {
        path: 'lookups/refrigerants/:id/edit',
        loadComponent: () => import('./pages/refrigerants/refrigerant-form.page').then(m => m.RefrigerantFormPage),
        data: { breadcrumb: 'REFRIGERANTS.EDIT' }
      },
      {
        path: 'lookups/models',
        loadComponent: () => import('./pages/models/model-list.page').then(m => m.ModelListPage),
        data: { breadcrumb: 'MODELS.TITLE' }
      },
      {
        path: 'lookups/models/new',
        loadComponent: () => import('./pages/models/model-form.page').then(m => m.ModelFormPage),
        data: { breadcrumb: 'MODELS.NEW' }
      },
      {
        path: 'lookups/models/:id/edit',
        loadComponent: () => import('./pages/models/model-form.page').then(m => m.ModelFormPage),
        data: { breadcrumb: 'MODELS.EDIT' }
      },
      {
        path: 'lookups/usual-feedbacks',
        loadComponent: () => import('./pages/usual-feedbacks/usual-feedback-list.page').then(m => m.UsualFeedbackListPage),
        data: { breadcrumb: 'USUAL_FEEDBACK.TITLE' }
      },
      {
        path: 'lookups/usual-feedbacks/new',
        loadComponent: () => import('./pages/usual-feedbacks/usual-feedback-form.page').then(m => m.UsualFeedbackFormPage),
        data: { breadcrumb: 'USUAL_FEEDBACK.NEW' }
      },
      {
        path: 'lookups/usual-feedbacks/:id/edit',
        loadComponent: () => import('./pages/usual-feedbacks/usual-feedback-form.page').then(m => m.UsualFeedbackFormPage),
        data: { breadcrumb: 'USUAL_FEEDBACK.EDIT' }
      },
      {
        path: 'admin/users',
        loadComponent: () => import('./pages/admin/users/user-list.page').then(m => m.UserListPage)
      },
      {
        path: 'admin/users/new',
        loadComponent: () => import('./pages/personnel/personnel-form.page').then(m => m.PersonnelFormPage)
      },
      {
        path: 'admin/users/:id/edit',
        loadComponent: () => import('./pages/personnel/personnel-form.page').then(m => m.PersonnelFormPage)
      },
      {
        path: 'admin/roles',
        loadComponent: () => import('./pages/admin/roles/role-list.page').then(m => m.RoleListPage)
      },
      {
        path: 'admin/roles/new',
        loadComponent: () => import('./pages/admin/roles/role-form.page').then(m => m.RoleFormPage)
      },
      {
        path: 'admin/roles/:id/edit',
        loadComponent: () => import('./pages/admin/roles/role-form.page').then(m => m.RoleFormPage)
      },
      // Multi-tenancy migration plan, Phase 3 — Super Admin tenant management
      {
        path: 'settings/tenants',
        loadComponent: () => import('./pages/settings/tenant-list.page').then(m => m.TenantListPage),
        data: { breadcrumb: 'TENANTS.TITLE' }
      },
      // Phase 6 — Customers
      {
        path: 'customers',
        loadComponent: () => import('./pages/customers/customer-list.page').then(m => m.CustomerListPage),
        data: { breadcrumb: 'CUSTOMERS.TITLE' }
      },
      {
        path: 'customers/new',
        loadComponent: () => import('./pages/customers/customer-form.page').then(m => m.CustomerFormPage),
        data: { breadcrumb: 'CUSTOMERS.NEW' }
      },
      {
        path: 'customers/:id/edit',
        loadComponent: () => import('./pages/customers/customer-form.page').then(m => m.CustomerFormPage),
        data: { breadcrumb: 'CUSTOMERS.EDIT' }
      },
      // Phase 6 — Partners
      {
        path: 'partners',
        loadComponent: () => import('./pages/partners/partner-list.page').then(m => m.PartnerListPage),
        data: { breadcrumb: 'PARTNERS.TITLE' }
      },
      {
        path: 'partners/new',
        loadComponent: () => import('./pages/partners/partner-form.page').then(m => m.PartnerFormPage),
        data: { breadcrumb: 'PARTNERS.NEW' }
      },
      {
        path: 'partners/:id/edit',
        loadComponent: () => import('./pages/partners/partner-form.page').then(m => m.PartnerFormPage),
        data: { breadcrumb: 'PARTNERS.EDIT' }
      },
      {
        path: 'partners/:id/view',
        loadComponent: () => import('./pages/partners/partner-view.page').then(m => m.PartnerViewPage),
        data: { breadcrumb: 'PARTNERS.VIEW_TITLE' }
      },
      {
        path: 'partners/:id/ledger',
        loadComponent: () => import('./pages/partners/partner-ledger.page').then(m => m.PartnerLedgerPage),
        data: { breadcrumb: 'PARTNERS.LEDGER_TITLE' }
      },
      // Phase 7 — Fleet
      {
        path: 'fleet',
        loadComponent: () => import('./pages/fleet/car-list.page').then(m => m.CarListPage),
        data: { breadcrumb: 'FLEET.TITLE' }
      },
      {
        path: 'fleet/new',
        loadComponent: () => import('./pages/fleet/car-form.page').then(m => m.CarFormPage),
        data: { breadcrumb: 'FLEET.NEW' }
      },
      {
        path: 'fleet/:id/edit',
        loadComponent: () => import('./pages/fleet/car-form.page').then(m => m.CarFormPage),
        data: { breadcrumb: 'FLEET.EDIT' }
      },
      {
        path: 'fleet/:id/detail',
        loadComponent: () => import('./pages/fleet/car-detail.page').then(m => m.CarDetailPage),
        data: { breadcrumb: 'FLEET.DETAIL_TITLE' }
      },
      // Warehouses
      {
        path: 'warehouses',
        loadComponent: () => import('./pages/warehouses/warehouse-list.page').then(m => m.WarehouseListPage),
        data: { breadcrumb: 'WAREHOUSES.TITLE' }
      },
      {
        path: 'warehouses/new',
        loadComponent: () => import('./pages/warehouses/warehouse-form.page').then(m => m.WarehouseFormPage),
        data: { breadcrumb: 'WAREHOUSES.NEW' }
      },
      {
        path: 'warehouses/:id/edit',
        loadComponent: () => import('./pages/warehouses/warehouse-form.page').then(m => m.WarehouseFormPage),
        data: { breadcrumb: 'WAREHOUSES.EDIT' }
      },
      // Phase 8 — Inventory
      {
        path: 'inventory',
        loadComponent: () => import('./pages/inventory/inventory.page').then(m => m.InventoryPage),
        data: { breadcrumb: 'INVENTORY.TITLE' }
      },
      {
        path: 'inventory/goods/:id',
        loadComponent: () => import('./pages/inventory/goods-detail.page').then(m => m.GoodsDetailPage),
        data: { breadcrumb: 'GOODS.DETAIL_TITLE' }
      },
      {
        path: 'inventory/goods/:id/edit',
        loadComponent: () => import('./pages/inventory/goods-form.page').then(m => m.GoodsFormPage),
        data: { breadcrumb: 'GOODS.EDIT' }
      },
      // Phase 9 — Devices
      {
        path: 'devices',
        loadComponent: () => import('./pages/devices/device-list.page').then(m => m.DeviceListPage),
        data: { breadcrumb: 'DEVICES.TITLE' }
      },
      // Phase 9 — Orders
      {
        path: 'orders',
        loadComponent: () => import('./pages/orders/order-list.page').then(m => m.OrderListPage),
        data: { breadcrumb: 'ORDERS.TITLE' }
      },
      {
        path: 'orders/new',
        loadComponent: () => import('./pages/orders/order-form.page').then(m => m.OrderFormPage),
        data: { breadcrumb: 'ORDERS.NEW' }
      },
      {
        path: 'orders/:id',
        loadComponent: () => import('./pages/orders/order-detail.page').then(m => m.OrderDetailPage),
        data: { breadcrumb: 'ORDERS.ORDER' }
      },
      {
        path: 'orders/:id/edit',
        loadComponent: () => import('./pages/orders/order-form.page').then(m => m.OrderFormPage),
        data: { breadcrumb: 'ORDERS.EDIT' }
      },
      {
        path: 'orders/:id/reopen',
        loadComponent: () => import('./pages/orders/order-reopen.page').then(m => m.OrderReopenPage),
        data: { breadcrumb: 'ORDERS.REOPEN' }
      },
      // Phase 9 — Work Orders
      {
        path: 'work-orders',
        loadComponent: () => import('./pages/work-orders/work-order-list.page').then(m => m.WorkOrderListPage),
        data: { breadcrumb: 'WORK_ORDERS.TITLE' }
      },
      {
        path: 'work-orders/new',
        loadComponent: () => import('./pages/work-orders/work-order-form.page').then(m => m.WorkOrderFormPage),
        data: { breadcrumb: 'WORK_ORDERS.NEW' }
      },
      // Maintenance-workflow-redesign-plan.md, Phase 4 — "Plan Next Day" dispatch board.
      // Must come before 'work-orders/:id' so the literal segment wins the route match.
      {
        path: 'work-orders/dispatch',
        loadComponent: () => import('./pages/work-orders/dispatch-board.page').then(m => m.DispatchBoardPage),
        data: { breadcrumb: 'DISPATCH.TITLE' }
      },
      {
        path: 'work-orders/:id/view',
        loadComponent: () => import('./pages/work-orders/work-order-view.page').then(m => m.WorkOrderViewPage),
        data: { breadcrumb: 'WORK_ORDERS.DETAIL_TITLE' }
      },
      {
        path: 'work-orders/:id',
        loadComponent: () => import('./pages/work-orders/work-order-detail.page').then(m => m.WorkOrderDetailPage),
        data: { breadcrumb: 'WORK_ORDERS.DETAIL_TITLE' }
      },
      // Phase 9 — Visits
      {
        path: 'visits',
        loadComponent: () => import('./pages/visits/visit-list.page').then(m => m.VisitListPage),
        data: { breadcrumb: 'VISITS.TITLE' }
      },
      {
        path: 'visits/:id/record',
        loadComponent: () => import('./pages/visits/visit-record.page').then(m => m.VisitRecordPage),
        data: { breadcrumb: 'VISITS.RECORD_TITLE' }
      },
      // Phase 10 — Finance
      {
        path: 'finance/sales',
        loadComponent: () => import('./pages/finance/sales-transaction-list.page').then(m => m.SalesTransactionListPage),
        data: { breadcrumb: 'SALES.TITLE' }
      },
      {
        path: 'finance/sales/new',
        loadComponent: () => import('./pages/finance/sales-transaction-form.page').then(m => m.SalesTransactionFormPage),
        data: { breadcrumb: 'SALES.NEW' }
      },
      {
        path: 'finance/sales/:id',
        loadComponent: () => import('./pages/finance/sales-transaction-detail.page').then(m => m.SalesTransactionDetailPage),
        data: { breadcrumb: 'SALES.DETAIL_TITLE' }
      },
      {
        path: 'finance/cash-positions',
        loadComponent: () => import('./pages/finance/cash-positions.page').then(m => m.CashPositionsPage),
        data: { breadcrumb: 'CASH.TITLE' }
      },
      {
        path: 'finance/transfers',
        loadComponent: () => import('./pages/finance/transfers.page').then(m => m.TransfersPage),
        data: { breadcrumb: 'TRANSFERS.TITLE' }
      },
      {
        path: 'finance/spending',
        loadComponent: () => import('./pages/finance/spending-list.page').then(m => m.SpendingListPage),
        data: { breadcrumb: 'SPENDING.TITLE' }
      },
      {
        path: 'finance/spending/new',
        loadComponent: () => import('./pages/finance/spending-form.page').then(m => m.SpendingFormPage),
        data: { breadcrumb: 'SPENDING.NEW' }
      },
      {
        path: 'finance/spending/:id/edit',
        loadComponent: () => import('./pages/finance/spending-form.page').then(m => m.SpendingFormPage),
        data: { breadcrumb: 'SPENDING.EDIT' }
      },
      {
        path: 'finance/invoices',
        loadComponent: () => import('./pages/finance/invoice-list.page').then(m => m.InvoiceListPage),
        data: { breadcrumb: 'INVOICES.TITLE' }
      },
      {
        path: 'finance/invoices/new',
        loadComponent: () => import('./pages/finance/invoice-form.page').then(m => m.InvoiceFormPage),
        data: { breadcrumb: 'INVOICES.NEW' }
      },
      {
        path: 'finance/invoices/:id',
        loadComponent: () => import('./pages/finance/invoice-detail.page').then(m => m.InvoiceDetailPage),
        data: { breadcrumb: 'INVOICES.DETAIL' }
      },
      {
        path: 'finance/vat-config',
        loadComponent: () => import('./pages/finance/vat-config.page').then(m => m.VatConfigPage),
        data: { breadcrumb: 'VAT.TITLE' }
      },
      // ZK — Security settings
      {
        path: 'settings/zk-tenant-setup',
        loadComponent: () => import('./pages/settings/zk-tenant-setup.page').then(m => m.ZkTenantSetupPage),
        data: { breadcrumb: 'ZK.TENANT_SETUP_TITLE' }
      },
      {
        path: 'settings/zk-enrollment',
        loadComponent: () => import('./pages/settings/zk-enrollment.page').then(m => m.ZkEnrollmentPage),
        data: { breadcrumb: 'ZK.ENROLLMENT_TITLE' }
      },
      {
        path: 'settings/zk-pending-enrollments',
        loadComponent: () => import('./pages/settings/zk-pending-enrollments.page').then(m => m.ZkPendingEnrollmentsPage),
        data: { breadcrumb: 'ZK.PENDING_TITLE' }
      },
      {
        path: 'settings/zk-recovery',
        loadComponent: () => import('./pages/settings/zk-recovery.page').then(m => m.ZkRecoveryPage),
        data: { breadcrumb: 'ZK.RECOVERY_PAGE_TITLE' }
      },
      {
        path: 'settings/zk-escrow-reset',
        loadComponent: () => import('./pages/settings/zk-escrow-reset.page').then(m => m.ZkEscrowResetPage),
        data: { breadcrumb: 'ZK.ESCROW_TITLE' }
      },
      {
        path: 'settings/zk-access',
        loadComponent: () => import('./pages/settings/zk-access.page').then(m => m.ZkAccessPage),
        data: { breadcrumb: 'ZK.ACCESS_HUB_TITLE' }
      },
      {
        path: 'settings/zk-phone-rotation',
        loadComponent: () => import('./pages/settings/zk-phone-rotation.page').then(m => m.ZkPhoneRotationPage),
        data: { breadcrumb: 'ZK.PHONE_ROTATION_TITLE' }
      },
      {
        path: 'settings/zk-audit-log',
        loadComponent: () => import('./pages/settings/zk-audit-log.page').then(m => m.ZkAuditLogPage),
        data: { breadcrumb: 'ZK.AUDIT_LOG_TITLE' }
      }
    ]
  }
];
